export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/homeIconDisabled.ce32cd41.svg","height":25,"width":26,"blurWidth":0,"blurHeight":0};